/* eslint-disable no-irregular-whitespace */
const BANNER = `
%c▄▄   %c█▀▀ ▄▀█ █▄░█ █░█ ▄▀█ █▀
%c▀%c▀%c█  %c█▄▄ █▀█ █░▀█ ▀▄▀ █▀█ ▄█

Copyright 2023 - ${__BUILD_YEAR__} sc07 & contributors
✨  https://sc07.dev/sc07/canvas   ✨
✨ https://canvas.fediverse.events ✨
`.slice(1);

const FORMATTING = [
  "color:red",
  "color:inherit",
  "color:red",
  "color:red; background-color: lime",
  "color:lime",
  "color:inherit",
];

export const printBanner = () => {
  console.log(BANNER, ...FORMATTING);
};
